export default __webpack_public_path__ + "static/media/greeting-image.4683b822.png";